/**
 * Renderer for the unresolvedIssues (IIM) column.
 *
 * Preserves the badge + link behavior from IimStatusCell/index.jsx.
 * Also renders the IIM column header icon (ai-plus icon).
 */
import React from 'react';
export function InspectionIimStatusRenderer({ item }) {
    const row = item;
    const count = row.unresolvedIssues;
    if (!count || count === 0)
        return null;
    const badge = React.createElement("span", { className: "qmb-badge--alert" }, count);
    return row.unresolvedIssuesPath ? React.createElement("a", { href: row.unresolvedIssuesPath }, badge) : badge;
}
